export default {
  computed: {
    storesQuickFilters() {
      return {
        title: 'Stores',
        filters: {
          columns: [
            {
              class: 'col-12 col-lg-6',
              filters: [
                {
                  name: 'reference',
                  label: this.$gettext('Reference'),
                  type: 'text',
                  value: '',
                  callback: (val) => {
                    const reference = val.trim()
                    if (reference.length > 0) {
                      return [['reference', 'ct', reference]]
                    } else {
                      return []
                    }
                  }
                },
                {
                  name: 'address',
                  label: this.$gettext('Address'),
                  type: 'address-autocomplete',
                  value: {
                    id: null,
                    formatted_address: null
                  },
                  callback: (val) => {
                    if (val.id) {
                      return [['place_id', 'eq', val.id]]
                    } else {
                      return []
                    }
                  }
                }
              ]
            }
          ]
        }
      }
    }
  }
}
